<template>
  <div class="rightContent">
    <div class="chartView" v-if="virtualType == 'charts'" key="charts">
      <div class="myReport" ref="myReport"></div>
    </div>
    <div class="tableView" v-else key="table">
      <el-table
        stripe
        :data="tableData"
        border
        style="width: 100%"
        height="100%"
        size="mini"
        @sort-change="sortChange"
      >
        <el-table-column
          type="index"
          :width="pagination.endIndex >= 1000 ? 80 : 50"
          align="center"
          :index="pagination.beginIndex"
        ></el-table-column>
        <el-table-column
          prop="uuid"
          label="UUID"
          min-width="110"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.uuid">{{ scope.row.uuid }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="type"
          label="类别"
          min-width="110"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.type">
              <span v-if="scope.row.p2pType">{{ scope.row.type.title }} - {{ scope.row.p2pType.title }}</span>
              <span v-else>{{ scope.row.type.title }}</span>
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="物料编码" min-width="110" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.itemCode">
              <span>{{ scope.row.itemCode.code }}</span>
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="customerId"
          label="所属客户"
          min-width="110"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.customer">{{ scope.row.customer.name }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="导入时间"
          min-width="110"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.createTime">{{
              scope.row.createTime
            }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="usageTime"
          label="使用时间"
          min-width="110"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.usageTime">{{ scope.row.usageTime }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="device"
          label="成品SN"
          min-width="110"
          align="center"
        >
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.device ? scope.row.device.sn : ''"
              placement="top"
              :open-delay="300"
            >
              <div class="textOverflow" v-if="scope.row.device">
                {{ scope.row.device.sn }}
              </div>
            </el-tooltip>
            <span v-if="!scope.row.device">-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="productionOrder"
          label="组装工单"
          min-width="110"
          align="center"
        >
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.productionOrder ? scope.row.productionOrder.orderNumber : ''"
              placement="top"
              :open-delay="300"
            >
              <div class="textOverflow" v-if="scope.row.productionOrder">
                {{ scope.row.productionOrder.orderNumber }}
              </div>
            </el-tooltip>
            <span v-if="!scope.row.productionOrder">-</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :pagination="pagination"
        @currentChange="currentChange"
        @sizeChange="sizeChange"
        @refreshBtn="getUuidSearch"
      ></pagination>
    </div>
    <myDialog ref="myDialog" :title="dialogTitle" @submitData="submitData" @dialogClose="dialogClose" width="450px">
      <template slot="content">
        <el-form ref="dialogForm" :rules="dialogRules" :label-width="labelWidth"
          :model="dialogForm"
        >
          <el-form-item v-if="uploadType!='DLinkNum' && uploadType!='H3C' && uploadType!='iflyTek'" label="客户" size="small" prop="customerId">
            <el-select placeholder="选择客户名称" filterable clearable
               v-model="dialogForm.customerId"
            >
              <el-option v-for="(item, index) in $parent.pullDownData.customerList"
                :key="index" :label="item.name" :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="物料编码" size="small" prop="projectItemCode" v-if="dialogTitle == '导入KeyId'">
            <el-select v-model="dialogForm.itemCode"
              placeholder="请选择物料编码" filterable clearable>
              <el-option
                v-for="(item, index) in pullDownData.keyIdItemCodeList"
                :key="index"
                :label="item.specification"
                :value="item.itemCode"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="物料编码" size="small" prop="projectItemCode" v-if="dialogTitle == '导入IMEI'">
            <el-select v-model="dialogForm.projectItemCode" placeholder="请输入物料编码" filterable clearable>
              <el-option
                  v-for="(item, index) in pullDownData.projectItemCodeList"
                  :key="index"
                  :label="item.itemCode"
                  :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="物料编码" size="small" prop="projectItemCode" v-if="dialogTitle == '导入NetId'">
            <el-select v-model="dialogForm.projectItemCode"
                       placeholder="请输入物料编码" filterable clearable>
              <el-option
                  v-for="(item, index) in pullDownData.netIdItemCodeList"
                  :key="index"
                  :label="item.itemCode"
                  :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="物料编码" size="small" prop="itemCode" v-if="dialogTitle == '导入涂鸦UUID' || dialogTitle == '导入MAC' || dialogTitle == '导入TUTK'">
            <el-select v-model="dialogForm.itemCode" v-if="dialogTitle == '导入涂鸦UUID'"
              placeholder="请选择物料编码" filterable clearable>
              <el-option
                v-for="(item, index) in pullDownData.tuyaItemCodeList"
                :key="index"
                :label="item.specification"
                :value="item.itemCode"
              ></el-option>
            </el-select>
            <el-select v-model="dialogForm.itemCode" v-if="dialogTitle == '导入MAC'"
              placeholder="请选择物料编码" filterable clearable>
              <el-option
                v-for="(item, index) in pullDownData.macItemCodeList"
                :key="index"
                :label="item.specification"
                :value="item.itemCode"
              ></el-option>
            </el-select>
            <el-select v-model="dialogForm.itemCode" v-if="dialogTitle == '导入TUTK'"
              placeholder="请选择物料编码" filterable clearable>
              <el-option
                v-for="(item, index) in pullDownData.tutkItemCodeList"
                :key="index"
                :label="item.specification"
                :value="item.itemCode"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="物料编码" size="small" prop="itemCode" v-if="uploadType=='H3C'">
            <el-select v-model="dialogForm.itemCode"
              placeholder="请选择物料编码" filterable clearable>
              <el-option
                v-for="(item, index) in pullDownData.h3cItemCodeList"
                :key="index"
                :label="item.specification"
                :value="item.itemCode"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="物料编码" size="small" prop="itemCode" v-if="uploadType=='iflyTek'">
            <el-select v-model="dialogForm.itemCode"
              placeholder="请选择物料编码" filterable clearable>
              <el-option
                v-for="(item, index) in pullDownData.iflyTekItemCodeList"
                :key="index"
                :label="item.specification"
                :value="item.itemCode"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="起始MAC" size="small" prop="startMac" v-if="dialogTitle == '导入MAC' && (dialogForm.customerId==54446251107946496 || dialogForm.customerId==49556885111701504 || dialogForm.customerId==51005753840119808 || dialogForm.customerId==50910239810392064 || dialogForm.customerId==108280423093907456 || dialogForm.customerId==64150675027931136 || dialogForm.customerId==61548442870362112 || dialogForm.customerId==124950244049440768)">
            <el-input placeholder="12位的MAC，如：BC51FE700000" clearable
              v-model="dialogForm.startMac"
            ></el-input>
          </el-form-item>
          <el-form-item label="结束MAC" size="small" prop="endMac" v-if="dialogTitle == '导入MAC' && (dialogForm.customerId==61548442870362112)">
            <el-input placeholder="12位的MAC，如：BC51FE7FFFFF" clearable
              v-model="dialogForm.endMac"
            ></el-input>
          </el-form-item>
          <el-form-item label="导入数量" size="small" prop="quantity" v-if="dialogTitle == '导入MAC' && (dialogForm.customerId==54446251107946496 || dialogForm.customerId==49556885111701504 || dialogForm.customerId==51005753840119808 || dialogForm.customerId==50910239810392064 || dialogForm.customerId==108280423093907456 || dialogForm.customerId==64150675027931136 || dialogForm.customerId==124950244049440768)">
            <el-input-number placeholder="请输入MAC的总数量（正整数）" clearable :min="1" :precision="0" :controls="false"
              v-model="dialogForm.quantity"
            ></el-input-number>
          </el-form-item>
          <el-form-item v-else-if="(dialogForm.customerId!=61548442870362112 && dialogForm.customerId!=124950244049440768)" :label="fileLabelName" size="small" prop="uploadFile">
            <input ref="fileUpload" class="fileUpload" type="file"
              @change="fileChange('fileUpload')"
            />
          </el-form-item>
          <el-form-item label="文件信息" size="small" prop="uploadFile2" v-if="dialogTitle == '导入涂鸦UUID' && dialogForm.itemCode!='18703B2150001'">
            <input ref="fileUpload2" class="fileUpload" type="file"
              @change="fileChange2('fileUpload2')"
            />
          </el-form-item>
        </el-form>
      </template>
    </myDialog>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import myDialog from "@/components/myDialog.vue";
import * as echarts from "echarts";
import {
  apiUuidSearch,
  apiUuidReport,
  apiUuidExport,
  apiUUIDUploadMac,
  apiUUIDUploadTuya,
  apiUUIDUploadTutk,
  apiUUIDUploadH3C,
  apiUUIDUploadIflyTek,
  apiUUIDImportMac,
  apiTuyaItemCodeList,
  apiKeyIdItemCodeList,
  apiTutkItemCodeList,
  apiMacItemCodeList,
  apiH3cItemCodeList,
  apiIflyTekItemCodeList,
  apiNetIdItemCodeList,
  apiUUIDUploadMyDLinkNum, getProductItemCodeList, apiUUIDUploadIMEI,apiUUIDUploadKeyId,apiUUIDUploadNetId
} from "@/api/virtualMaterial.js";
import { apiUploadFile } from "@/api/filesUpload.js";
export default {
  props: {
    virtualSearchForm: {
      type: Object,
    },
  },
  components: {
    pagination,
    myDialog,
  },
  computed: {
    fileLabelName() {
      switch (this.uploadType) {
        case "DLinkNum":
          return "*.csv";
        case "IMEI":
          return "*.xls/*.xlsx";
        case "MAC":
          return "*.txt";
        case "TUTK":
          return "*.xls/*.xlsx";
        case "涂鸦":
          return "授权文件";
        case "H3C":
        case "iflyTek":
          return "DeviceId";
        case "NetId":
          return "*.txt";
        default:
          return "";
      }
    },
  },
  data() {
    return {
      virtualType: "table",
      projectItemCodeId: "",
      pullDownData: {
        uuidTypeList: [],
        P2PTypeList: [],
        keyIdItemCodeList: [],
        tuyaItemCodeList: [],        
        tutkItemCodeList: [],
        macItemCodeList: [],
        h3cItemCodeList:[],
        iflyTekItemCodeList:[],
        netIdItemCodeList:[],
        projectItemCodeList: []
      },
      tableData: [],
      desc: undefined,
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10,
      },
      virtualChartsData: {},
      dialogTitle: "",
      dialogForm: {},
      dialogRules: {
        itemCode: [
          { required: true, message: "物料编码不能为空！", trigger: "change" },
        ],
        uploadFile: [
          { required: true, message: "文件不能为空！", trigger: "change" },
        ],
        uploadFile2: [
          { required: true, message: "文件不能为空！", trigger: "change" },
        ],
        quantity: [
          { required: true, message: "数量不能为空！", trigger: "blur" },
        ],
        startMac: [
          { required: true, message: "起始MAC不能为空！", trigger: "change" },
        ],
        endMac: [
          { required: true, message: "结束MAC不能为空！", trigger: "change" },
        ]
      },
      uploadType: "",
      labelWidth: this.$store.state.labelWidth,
    };
  },
  methods: {
    // 切换虚拟--视图
    async virtualChange(value, virtualCallback) {      
      if (this.pullDownData.keyIdItemCodeList.length==0) {
        const res = await apiKeyIdItemCodeList();
        if (res.code==0) {
          this.pullDownData.keyIdItemCodeList = res.data;
        }
      }
      if (this.pullDownData.tuyaItemCodeList.length==0) {
        const res = await apiTuyaItemCodeList();
        if (res.code==0) {
          this.pullDownData.tuyaItemCodeList = res.data;
        }
      }
      if (this.pullDownData.tutkItemCodeList.length==0) {
        const res1 = await apiTutkItemCodeList();
        if (res1.code==0) {
          this.pullDownData.tutkItemCodeList = res1.data;
        }
      }
      if (this.pullDownData.macItemCodeList.length==0) {
        const res1 = await apiMacItemCodeList();
        if (res1.code==0) {
          this.pullDownData.macItemCodeList = res1.data;
        }
      }
      if (this.pullDownData.h3cItemCodeList.length==0) {
        const res = await apiH3cItemCodeList();
        if (res.code==0) {
          this.pullDownData.h3cItemCodeList = res.data;
        }
      }
      
      if (this.pullDownData.netIdItemCodeList.length==0) {
        const res = await apiNetIdItemCodeList();
        if (res.code==0) {
          this.pullDownData.netIdItemCodeList = res.data;
        }
      }
      if (this.pullDownData.iflyTekItemCodeList.length==0) {
        const res = await apiIflyTekItemCodeList();
        if (res.code==0) {
          this.pullDownData.iflyTekItemCodeList = res.data;
        }
      }
      this.virtualType = value;
      if (value == "table") {
        this.getUuidSearch("", virtualCallback);
      } else {
        this.getUuidReport(virtualCallback);
      }
    },

    // itemcode表里获取物料编码
    async getProductItemCodeList(value) {
      if (this.pullDownData.projectItemCodeList.length==0) {
        const res = await getProductItemCodeList();
        if (res.code==0) {
          this.pullDownData.projectItemCodeList = res.data;
        }
      }
      this.projectItemCodeId = value;
    },
    // 表格数据
    async getUuidSearch(remove, callback) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      const res = await apiUuidSearch({
        ...this.virtualSearchForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy,
      });
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        if (callback) callback();
      }
    },
    // 库存报表数据
    async getUuidReport(callback) {
      const res = await apiUuidReport({
        customerId: this.virtualSearchForm.customerId,
        type: this.virtualSearchForm.type,
        p2pType: this.virtualSearchForm.p2pType,
        itemCode: this.virtualSearchForm.itemCode,
      });
      if (res.code == 0) {
        this.virtualChartsData = res.data;
        let reoprtName = [],
          reoprtAll = [],
          reoprtUsed = [],
          reoprtRepertory = [],
          canvasIndex = 1,
          canvasTitle = [],
          usedColor = [
            "#759aa0",
            "#8dc1a9",
            "#eedd78",
            "#73b9bc",
            "#91ca8c",
            "#11cd8c",
          ],
          repertoryColor = [
            "#be615d",
            "#e69d87",
            "#ea7e53",
            "#73a373",
            "#7289ab",
            "#6281ab",
          ],
          canvasSeries = [];

        for (const key in res.data) {
          reoprtName.push(key);
          reoprtAll.push(res.data[key].all);
          reoprtUsed.push(res.data[key].used);
          reoprtRepertory.push(res.data[key].all - res.data[key].used);
          canvasTitle.push({
            text: key,
            left: 20 + ((canvasIndex - 1) % 3) * 30 + "%",
            top: 3 + Math.floor(canvasIndex / 4) * 45 + "%",
            subtext: "总计：" + res.data[key].all,
            textAlign: "center",
            textStyle: {
              color: "#303133",
            },
          });
          canvasSeries.push({
            type: "pie",
            radius: 60,
            center: [
              20 + ((canvasIndex - 1) % 3) * 30 + "%",
              30 + Math.floor(canvasIndex / 4) * 45 + "%",
            ],
            encode: {
              itemName: "product",
              value: key,
            },
            label: {
              color: "#303133",
              formatter: (params) => {
                return (
                  params["name"] +
                  "：" +
                  (params["name"] == "已用"
                    ? res.data[key].used
                    : res.data[key].all - res.data[key].used)
                );
              },
            },
            itemStyle: {
              color: function (params) {
                return params["name"] == "已用"
                  ? usedColor[params.seriesIndex]
                  : repertoryColor[params.seriesIndex];
              },
            },
          });
          canvasIndex++;
        }
        let myReport = echarts.init(this.$refs.myReport);
        myReport.clear();
        let option = {
          backgroundColor: "#fff",
          tooltip: {},
          title: canvasTitle,
          dataset: {
            source: [
              ["product", ...reoprtName],
              ["库存", ...reoprtRepertory],
              ["已用", ...reoprtUsed],
            ],
          },
          series: canvasSeries,
        };
        myReport.setOption(option);
        if (Object.keys(res.data).length == 0) {
          this.$message({
            message: "图表数据为空",
            type: "warning",
          });
        }
        if (callback) callback();
      }
    },
    downloadFileBtn(type) {
      if (type == "图片" && Object.keys(this.virtualChartsData).length==0) {
        this.$message({
          type: "warning",
          message: "虚拟物料暂无数据可供导出",
        });
      }
      this.$confirm(`确定导出【虚拟物料】的${type}吗？`, `导出${type}`, {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          if(type == "图片") {
            this.$canvasDownload(
              ".materialManage .chartView .myReport canvas",
              "虚拟物料-库存报表"
            );
          } else {
            const res = await apiUuidExport({
              customerId: this.virtualSearchForm.customerId,
              type: this.virtualSearchForm.type,
              p2pType: this.virtualSearchForm.p2pType,
              wakeup: this.virtualSearchForm.wakeup,
              export: true
            });
            if(res.code == 0) {
              this.$downloadFile(res.fid, res.fileName, res.secretKey);
            }
          }
        })
    },
    // 导入按钮
    uploadFileBtn(type) {
      this.uploadType = type;
      if (type == "DLinkNum") {
        this.dialogTitle = type;
      } else if (type == "涂鸦") {
        this.dialogTitle = `导入${type}UUID`;
      } else {
        this.dialogTitle = `导入${type}`;
      } 
      this.$refs.myDialog.dialogVisible = true;
    },
    // 文件上传
    async fileChange(refName) {
      this.$set(this.dialogForm, "uploadFile", this.$refs[refName].files[0]);
      this.$refs.dialogForm.validateField("uploadFile");
    },
    async fileChange2(refName) {
      this.$set(this.dialogForm, "uploadFile2", this.$refs[refName].files[0]);
      this.$refs.dialogForm.validateField("uploadFile2");
    },
    // 确认新建
      submitData() {
      this.$refs.dialogForm.validate(async (valid) => {
        if (valid) {
          let res = {};
          if (this.dialogTitle == '导入MAC' && (this.dialogForm.customerId==54446251107946496n || this.dialogForm.customerId==49556885111701504n || this.dialogForm.customerId==51005753840119808n || this.dialogForm.customerId==50910239810392064n || this.dialogForm.customerId==108280423093907456n || this.dialogForm.customerId==64150675027931136n || this.dialogForm.customerId==61548442870362112n || this.dialogForm.customerId==124950244049440768n)) {
            res = await apiUUIDImportMac({
                ...this.dialogForm
              });
          } else {
            let fd = new FormData();
            fd.append("file", this.dialogForm.uploadFile);
            fd.append("secret", true);
            res = await apiUploadFile(fd);
            if (res.code == 0) {
              this.$set(this.dialogForm, "fid", res.fid);
            } else {
              return false;
            }
            if (this.dialogTitle == `导入涂鸦UUID` && this.dialogForm.uploadFile2) {
              res = {};
              fd = new FormData();
              fd.append("file", this.dialogForm.uploadFile2);
              fd.append("secret", true);
              res = await apiUploadFile(fd);
              if (res.code == 0) {
                this.$set(this.dialogForm, "extendFid", res.fid);
              } else {
                return false;
              }
            }
            if (this.uploadType == "MAC") {
              res = await apiUUIDUploadMac({
                ...this.dialogForm,
                uploadFile: undefined,
              });
            } else if (this.uploadType == "涂鸦") {
              res = await apiUUIDUploadTuya({
                ...this.dialogForm,
                uploadFile: undefined,
                uploadFile2: undefined,
              });
            } else if (this.uploadType == "TUTK") {
              res = await apiUUIDUploadTutk({
                ...this.dialogForm,
                uploadFile: undefined,
                uploadFile2: undefined,
              });
            } else if (this.uploadType == "H3C") {
              res = await apiUUIDUploadH3C({
                ...this.dialogForm,
                uploadFile: undefined
              });
            } else if (this.uploadType == "iflyTek") {
              res = await apiUUIDUploadIflyTek({
                ...this.dialogForm,
                uploadFile: undefined
              });
            } else if (this.uploadType == "DLinkNum") {
              res = await apiUUIDUploadMyDLinkNum({
                ...this.dialogForm,
                uploadFile: undefined
              });
            } else if (this.uploadType == "KeyId") {              
              res = await apiUUIDUploadKeyId({
                ...this.dialogForm,
                uploadFile: undefined
              });
            } else if (this.uploadType == "IMEI") {
              res = await apiUUIDUploadIMEI({
                ...this.dialogForm,
                uploadFile: undefined
              });
            } else if (this.uploadType == "NetId") {
              res = await apiUUIDUploadNetId({
                ...this.dialogForm,
                uploadFile: undefined
              });
            } else {
              this.$message({
                type: "warning",
                message: "接口未实现",
              });
              return false;
            }
          }
          if (res.code == 0) {
            this.$refs.myDialog.dialogVisible = false;
            this.getUuidSearch();
            this.getUuidReport();
            this.$message({
              type: "success",
              message: res.msg,
            });
          }
        } else {
          return false;
        }
      });
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.dialogForm.resetFields();
      this.dialogForm = {};
      this.$refs.fileUpload.value = "";
      if (this.$refs.fileUpload2) {
        this.$refs.fileUpload2.value = "";
      }
    },
    // 清除查询
    onClear() {
      this.pagination.currentPage = 1;
      if (this.virtualType == "table") {
        this.getUuidSearch();
      } else {
        this.getUuidReport();
      }
    },
    // 确认查询
    onSearch() {
      if (this.virtualType == "table") {
        this.pagination.currentPage = 1;
        this.getUuidSearch();
      } else {
        this.getUuidReport();
      }
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getUuidSearch();
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getUuidSearch();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getUuidSearch();
    },
  },
};
</script>

<style lang="less" scoped>
.chartView {
  height: 100%;
  .myReport {
    width: 1000px;
    height: 500px;
    margin: 20px auto;
  }
}
.tableView {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
